import styled, { css } from "styled-components";
import { detailsBig, detailsSmall, h3, h5, paragraph } from "@/styles/typography";

const colors: { [key: string]: any } = {
  blue: '#124d60',
  green: '#316558',
  red: '#9b2323',
  orange: '#af622b'
}

const stickyColors: { [key: string]: any } = {
  blue: '#14303b',
  green: '#204a40',
  red: '#841c1c',
  orange: '#894210'
}

const stickyStyles = css`
  word-break: break-all;
`;

const Type = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0.5rem;
  text-transform: none;
  font-size: 12px;
  padding: 0.2rem;
`;

export const StickyContentButton = styled.a<{ background?: string, sticky?: boolean, mixed?: boolean }>`
  ${detailsBig}
  ${stickyStyles}

  &.report-4, &.report-5 {
    display: none;
  }

  font-weight:  ${({ sticky }) => sticky ? '400' : '700'};
  font-family:  ${({ sticky }) => sticky ? 'Avenir Next' : 'Avenir Next Bold'};
  min-width: ${({ sticky }) => sticky ? 'fit-content' : ''};
  
  font-size:  ${({ sticky }) => sticky ? '16px' : ''};
  padding: ${({ sticky }) => sticky ? '8px 23px' : '20px 48px 16px 48px'};
  padding-top: ${({ mixed }) => mixed ? '2rem' : ''};
  position: ${({ mixed }) => mixed ? 'relative' : ''};

  .arrow_btn-active {
    display: none;
  }

  &:hover {
    .arrow_btn-active {
      display: block;
    }
    .arrow_btn {
      display: none;
    }
  }

  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  color: ${({ theme }) => theme.textColors.secondary};
  border: ${({ theme, background }) => background ? stickyColors[background] : theme.colors.primary} 2px solid;
  background: ${({ theme, background }) => background ? stickyColors[background] : theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  white-space: ${({ sticky }) => sticky ? 'break-spaces' : 'nowrap'};
  text-align:  ${({ sticky }) => sticky ? 'start' : 'center'};;

  .arrow_btn-active {
    display: none;
  }

  &:hover {
    .arrow_btn-active {
      display: block;
    }
    .arrow_btn {
      display: none;
    }
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: white;
      color: ${({ theme }) => theme.colors.primary};
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    ${detailsSmall}
    height: 46px;
    max-width: 100%;
    width: 100%;

    &:hover {
      color: ${({ theme }) => theme.textColors.secondary};
      border: ${({ theme }) => theme.colors.primary} 2px solid;
      background: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const StyledDefaultButtonDark = styled.div<{ background?: string, sticky?: boolean, expandCard?: boolean, className?: string, mixed?: boolean }>`
  ${detailsBig}
  ${stickyStyles}

  &.article-4, &.article-5 {
    display: none;
  }

  &.${({ className }) => className} {
    .preamble, a {
      display: ${({ expandCard }) => expandCard ? 'flex' : 'none'};
    }
  }

  div {
    margin-right: 1rem;
  }

  display: flex;
  flex-direction: column;
  position: relative;
  font-weight:  ${({ sticky }) => sticky ? '400' : '700'};
  font-family:  ${({ sticky }) => sticky ? 'Avenir Next' : 'Avenir Next Bold'};
  min-width: ${({ sticky }) => sticky ? 'fit-content' : ''};
  
  font-size:  ${({ sticky }) => sticky ? '16px' : ''};
  padding: ${({ sticky }) => sticky ? '8px 23px' : '20px 48px 16px 48px'};
  padding-top: ${({ mixed }) => mixed ? '2rem' : ''};

  .arrow_btn-active {
    display: none;
  }

  #read_more {
    text-transform: none;
    padding: 0.5rem;
    text-align: end;
    width: 100%;
    justify-content: end;
    color: white;
    text-decoration: none;

    img {
      margin-top: -0.2rem;
      position: unset;
      transform: scale(0.6);
    }
  }
    
  &:hover {
    .arrow_btn-active {
      display: block;
    }
   #read_more {
      color: ${colors.green};
     }
    .arrow_btn {
      display: none;
    }

    .preamble {
      border-color: ${colors.green};
    }
  }

  .arrow_btn, .arrow_btn-active {
    position: absolute;
    right: 1rem;
    top: 1rem;
    transform: ${({ expandCard }) => expandCard ? 'rotate(180deg) scale(0.6)' : ''};
  }
  
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  color: ${({ theme }) => theme.textColors.secondary};
  border: ${({ theme, background }) => background ? colors[background] : theme.colors.primary} 2px solid;
  background: ${({ theme, background }) => background ? colors[background] : theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  white-space: ${({ sticky }) => sticky ? 'break-spaces' : 'nowrap'};
  text-align:  ${({ sticky }) => sticky ? 'start' : 'center'};;

  .arrow_btn-active {
    display: none;
  }

  &:hover {
    .arrow_btn-active {
      display: block;
    }
    .arrow_btn {
      display: none;
    }
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: white;
      color: ${({ theme }) => theme.colors.primary};
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    ${detailsSmall}
    height: 46px;
    max-width: 100%;
    width: 100%;

    &:hover {
      color: ${({ theme }) => theme.textColors.secondary};
      border: ${({ theme }) => theme.colors.primary} 2px solid;
      background: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const Container = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 580px;
  margin-bottom: ${({ theme }) => theme.margins.bottom};
  padding: 150px 0 100px 0;

  .gatsby-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-bottom: ${({ theme }) => theme.margins.bottomMobile};
  }
`;

const Preamble = styled.p`
  border-top: 2px solid white;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  font-size: 14px;
  text-transform: none;
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &::before {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: block;
  }
`;

const GridItem = styled.div`
  a {
    padding: 12px;
    font-size: 16px;
  }
`;

const StickyGridItem = styled.div`
  margin-bottom: 0;
  margin-top: 1rem;
`;

const Title = styled.div`
  display: flex;
  max-width: 90%;
  flex-direction: column;
  margin-bottom: 50px;
`;

const H3Title = styled(h3)<{ backgroundColor: string }>`
  color: ${(props) =>
    props.backgroundColor === "white"
      ? ({ theme }) => theme.colors.primary
      : ({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  padding-top: 10px;
  width: fit-content;
  margin-bottom: 1rem;
  letter-spacing: 4px;
`;

const StickyTitle = styled(Title)`
  margin-bottom: 0;
`;

const StubTitle = styled(detailsBig)`
  color: ${({ theme }) => theme.textColors.secondary};
  margin: 50px 0;
`;

const Paragraph = styled(paragraph)`
  color: ${({ theme }) => theme.textColors.secondary};
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 25px;
  margin-bottom: 70px;

  @media ${({ theme }) => theme.breakpoints.md} {
    flex-direction: column;
    margin-bottom: 30px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 25px;
  max-width: 80%;
  margin-bottom: 70px;

  @media ${({ theme }) => theme.breakpoints.md} {
    flex-direction: column;
    margin-bottom: 30px;
  }
`;

const LinkContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 80px;
  background-color: rgba(34, 76, 93, 0.8);

  .active {
    background-color: rgb(20 48 59);
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    display: none;
  }
`;

const MobileLinkContainer = styled.div`
  display: none;

  @media ${({ theme }) => theme.breakpoints.sm} {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 80px;
    background-color: rgba(34, 76, 93, 0.8);

    .swiper-button-next,
    .swiper-button-prev {
      color: ${({ theme }) => theme.textColors.secondary}!important;
    }
  }
`;

const Link = styled.a`
  display: flex;
  height: 80px;
  width: 324px;
  max-width: 100vw;
  border-left: 2px solid ${({ theme }) => theme.textColors.secondary};
  color: ${({ theme }) => theme.textColors.secondary};
  text-decoration: none;
  text-transform: uppercase;
  padding-left: 20px;
  padding-right: 20px;
  transition: all 0.1s ease-in-out;
  overflow: hidden;
  align-items: center;

  &:last-of-type {
    border-right: 2px solid ${({ theme }) => theme.textColors.secondary};
  }
  
  img {
    transition: all 0.1s ease-in-out;
    width: 28px;
    height: 20px;
    margin-left: 5px;
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: rgba(34, 76, 93, 1);

      img {
        transform: translateX(30px);
        filter: ${({ theme }) => theme.filter.gold};
      }

      p {
        filter: ${({ theme }) => theme.filter.gold};
      }
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-left: 50px;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
  width: 100%;
`;

const LinkTitle = styled(h5)``;

const LinkText = styled(detailsSmall)`
  display: inline-flex;
  align-items: center;
  gap: 5px;

  transition: all 0.1s ease-in-out;
`;

const PulsatingCircle = styled.div`
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  animation: pulse-white 4s infinite;

  @keyframes pulse-white {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    }

    30% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      animation: none;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.7);

      img {
        filter: ${({ theme }) => theme.filter.gold};
      }
    }
  }
`;

const ArrowDown = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;

  animation: bounce2 2s ease infinite;

  @keyframes bounce2 {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translate(-50%, -50%) rotate(90deg);
    }
    40% {
      transform: translate(-50%, -40%) rotate(90deg);
    }
    60% {
      transform: translate(-50%, -45%) rotate(90deg);
    }
  }
`;

const ButtonWrapper = styled.div`
  margin-bottom: 1rem;
`;

const Img = styled.img`
  margin-left: 1rem;
  margin-bottom: 0.2rem;
  transform: scale(0.6);
`;

const S = {
  StyledDefaultButtonDark,
  Preamble,
  Container,
  VideoContainer,
  GridContainer,
  GridItem,
  StickyGridItem,
  Title,
  StickyTitle,
  StubTitle,
  Paragraph,
  Wrapper,
  TextWrapper,
  LinkContainer,
  MobileLinkContainer,
  Link,
  LinkTitle,
  LinkText,
  LinkWrapper,
  PulsatingCircle,
  ArrowDown,
  ButtonWrapper,
  Img,
  H3Title,
  Type,
  StickyContentButton
};

export default S;
